import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {IAppliedFiltersUpdater, IAppliedFiltersUpdaterToken} from '../applied-filters-updater';
import {
    AdvancedFilterFieldTypesEnum, AdvancedFilterOperatorEnum, AdvanceFilterParamType, IAdvanceFilter, IAdvanceFilterComponent
} from './advance-filter';

@Component({
    template: ''
})
export abstract class AbstractFilterComponent<O = unknown> implements IAdvanceFilterComponent<AdvanceFilterParamType>, OnInit {
    protected _value: string | string[];

    @Input() operator: AdvancedFilterOperatorEnum;
    @Input() item: IAdvanceFilter<AdvanceFilterParamType>;
    @Input() options:O;

    @Input()
    public set filterValue(value: string | string[]) {
        this._value = value;
    }

    public get filterValue(): string | string[] {
        return this._value;
    }

    @Input() popover: NgbPopover;

    readonly field_type: AdvancedFilterFieldTypesEnum  = AdvancedFilterFieldTypesEnum.document_field;
    public filterForm: FormGroup;

    constructor(
        protected _formBuilder: FormBuilder,
        @Inject(IAppliedFiltersUpdaterToken) protected filterUpdater: IAppliedFiltersUpdater<AdvanceFilterParamType>) {

        this.setUpForm();

    }

    ngOnInit(): void {
        if (this._value) {
            this.filterForm.controls['value']?.setValue(this._value);
        }

        if (this.operator) {
            this.filterForm.controls['operator']?.setValue(this.operator);
        }
    }

    setUpForm(): void {
        this.filterForm = this._formBuilder.group({
            value: [this._value, [Validators.required]],
            operator: [this.operator, [Validators.required]],
        });
    }

    applyFilter() {
        if (this.filterForm.valid) {
            this.filterUpdater.update({
                ...this.item,
                isApplied: true,
                operator: this.filterForm.value.operator,
                value: this.filterForm.value.value,
            });
            this.popover.close();
        }
    }

}
